import React from 'react';
import './LegalPages.css';

const TermsOfService = ({ onClose }) => {
  return (
    <div className="legal-overlay">
      <div className="legal-modal">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <button className="legal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        
        <div className="legal-content">
          <p className="legal-updated">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section>
            <h2>Acceptance of Terms</h2>
            <p>By accessing and using Immuta Hash Gallery ("the Service"), you accept and agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not use our service.</p>
          </section>

          <section>
            <h2>Description of Service</h2>
            <p>Immuta Hash Gallery is a web-based platform that allows users to:</p>
            <ul>
              <li>Connect Hedera-compatible wallets</li>
              <li>Display NFTs in 3D gallery environments</li>
              <li>Create and customize virtual galleries</li>
              <li>Share galleries with others</li>
            </ul>
          </section>

          <section>
            <h2>Beta Software Disclaimer</h2>
            <p><strong>IMPORTANT:</strong> This platform is currently in beta testing. The service may contain bugs, errors, or incomplete features. Use at your own risk. We are not liable for:</p>
            <ul>
              <li>Data loss or corruption</li>
              <li>Service interruptions or downtime</li>
              <li>Unexpected behavior or errors</li>
              <li>Loss of access to galleries or content</li>
            </ul>
          </section>

          <section>
            <h2>User Accounts and Wallets</h2>
            <p>To use our service, you must:</p>
            <ul>
              <li>Connect a compatible Hedera wallet</li>
              <li>Be at least 13 years old</li>
              <li>Provide accurate information</li>
              <li>Maintain the security of your wallet</li>
            </ul>
            <p>You are solely responsible for your wallet security and any activities that occur through your connected wallet.</p>
          </section>

          <section>
            <h2>Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Display illegal, offensive, or inappropriate content</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Attempt to hack, disrupt, or compromise the platform</li>
              <li>Use the service for commercial purposes without permission</li>
              <li>Impersonate others or create fake galleries</li>
              <li>Upload content that violates intellectual property rights</li>
            </ul>
          </section>

          <section>
            <h2>Content and NFTs</h2>
            <p>When displaying NFTs in your gallery:</p>
            <ul>
              <li>You must own or have permission to display the NFTs</li>
              <li>We do not verify ownership or authenticity of NFTs</li>
              <li>You are responsible for ensuring content legality</li>
              <li>We reserve the right to remove inappropriate content</li>
            </ul>
          </section>

          <section>
            <h2>Financial Disclaimers</h2>
            <p><strong>Not Financial Advice:</strong> This platform is for display purposes only. We do not provide:</p>
            <ul>
              <li>Investment advice or recommendations</li>
              <li>NFT valuation or pricing information</li>
              <li>Trading or marketplace functionality</li>
              <li>Financial planning or investment services</li>
            </ul>
            <p>All NFT investments carry risk. Do your own research.</p>
          </section>

          <section>
            <h2>Service Availability</h2>
            <p>We strive to maintain service availability but do not guarantee:</p>
            <ul>
              <li>Uninterrupted access to the platform</li>
              <li>Error-free operation</li>
              <li>Continuous availability of all features</li>
              <li>Compatibility with all devices or browsers</li>
            </ul>
          </section>

          <section>
            <h2>Privacy and Data</h2>
            <p>Your privacy is important to us. Please review our Privacy Policy for information about how we collect, use, and protect your data. By using our service, you consent to our data practices as described in the Privacy Policy.</p>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>The Immuta Hash Gallery platform, including its code, design, and functionality, is owned by us and protected by intellectual property laws. You may not copy, modify, or redistribute our platform without permission.</p>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR:</p>
            <ul>
              <li>Direct, indirect, incidental, or consequential damages</li>
              <li>Loss of profits, data, or business opportunities</li>
              <li>Service interruptions or data loss</li>
              <li>Third-party actions or content</li>
            </ul>
            <p>Our total liability shall not exceed $100 or the amount you paid for premium features, whichever is less.</p>
          </section>

          <section>
            <h2>Indemnification</h2>
            <p>You agree to indemnify and hold us harmless from any claims, damages, or expenses arising from:</p>
            <ul>
              <li>Your use of the service</li>
              <li>Your violation of these terms</li>
              <li>Content you display in your galleries</li>
              <li>Your wallet or blockchain activities</li>
            </ul>
          </section>

          <section>
            <h2>Termination</h2>
            <p>We may terminate or suspend your access at any time for:</p>
            <ul>
              <li>Violation of these terms</li>
              <li>Inappropriate content or behavior</li>
              <li>Technical or security reasons</li>
              <li>Legal compliance requirements</li>
            </ul>
            <p>You may disconnect your wallet and stop using the service at any time.</p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>We may update these Terms of Service periodically. We will notify users of material changes via email or platform notifications. Continued use after changes constitutes acceptance of new terms.</p>
          </section>

          <section>
            <h2>Governing Law</h2>
            <p>These terms are governed by the laws of [Your Jurisdiction]. Any disputes shall be resolved through binding arbitration or in the courts of [Your Jurisdiction].</p>
          </section>

          <section>
            <h2>Contact Information</h2>
            <p>For questions about these Terms of Service, contact us via:</p>
            <p>Discord: <a href="https://discord.gg/wWrwKhJu54" target="_blank" rel="noopener noreferrer">https://discord.gg/wWrwKhJu54</a><br />
            Subject: Terms of Service Inquiry</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;